import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Dropdown } from 'react-bootstrap'
import { useAppSelector, useAppDispatch } from "../../app/hooks"
import { getAuditAsync, getAuditTimeEntriesAsync, getAccountEmployeeTimeEntryDetailsAsync } from "./AccountAuditSlice";
import { KTIcon, KTSVG, useDebounce } from '../../_metronic/helpers';
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import Select, { StylesConfig } from 'react-select';
import CustomPagination from "../../common/Pagination";
import { paginationStyles } from "../../common/timeLiveFunction";
import { getPageSizeArray } from "../../common/timeLiveFunction";
import { getAndSetCustomFieldValues, formatCurrntDateTime, FormatInvoiceDecimalNumber, formatDateWithDateAndMonthName, getFilteredList, getValueFromResource } from "../../common/timeLiveFunction";
import AccountAuditItem from "./AccountAuditItems";
import Loader from "../../common/Loader";
import moment from "moment";
import clsx from "clsx";
import CanvasLoader from "../../common/CanvasLoader";
import fetchAPI from '../../common/fetchAPI';

interface SelectedObjectType {
    Id: any;
    TableName: string;
    Title: string;
}

const TimesheetAudit = () => {
    const dispatch = useAppDispatch();
    const modelRef = useRef<any>(null);
    const { t } = useTranslation();
    const { accountAuditList, timeEntryAuditList, employeeTimeEntryList, isReload, isLoading } = useAppSelector((state) => state.audit);
    const { decimalPlaces, cultureInfoName, pageId, menuList, maxMenuHeight, IsList, IsAdd, IsEdit, IsDelete } = useAppSelector((state) => state.globalState);
    const [selectedObject, setSelectedObject] = useState<SelectedObjectType | null>(null);
    const [showModal, setShowModal] = useState(false);
    const [pageSize, setPageSize] = useState(10);
    const [pageSizesheet, setPageSizesheet] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPagesheet, setCurrentPagesheet] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchTermSheet, setSearchTermSheet] = useState('');
    const location = useLocation();
    const { obj } = location.state || {};
    document.title = obj.Title + ` | Livetecs`;
    const [tab, setTab] = useState('TimesheetPeriodAudit');
    const [isLoader, setIsLoader] = useState(true);
    const [customFieldsArray, SetCustomFieldsArray] = useState<any | ''>([]);

    // useEffect(() => {
    //     if (isReload) {
    //         dispatch(getAuditAsync({ TableName: 'AccountEmployeeTimeEntryPeriod', Id: obj.Id }));
    //         dispatch(getAuditTimeEntriesAsync({ TableName: 'AccountEmployeeTimeEntry', Id: obj.Id }));
    //     }
    // }, [isReload])

    const setCustomFieldValues = (databaseFieldName: string, value: any) => {
        const field = customFieldsArray.find(
            (item: any) => item.DatabaseFieldName === databaseFieldName
        );
        if (!field || value === null || value === undefined || value === '') {
            return value;
        }
        switch (field.MasterCustomDataTypeName) {
            case 'Number':
                if (value.toString() === 'NaN' || isNaN(parseFloat(value))) {
                    return '';
                }
                return FormatInvoiceDecimalNumber(
                    cultureInfoName.toString(),
                    value,
                    decimalPlaces
                );
            case 'Date':
                return formatDateWithDateAndMonthName(
                    value,
                    cultureInfoName.toString()
                );
            default:
                return value;
        }
    };

    useEffect(() => {
        dispatch(getAuditAsync({ TableName: 'AccountEmployeeTimeEntryPeriod', Id: obj.Id }));
        dispatch(getAccountEmployeeTimeEntryDetailsAsync(obj.Id));
    }, [dispatch])

    useEffect(() => {
        getCustomFieldTemplateByMasterEntityTypeIdAsync();
    }, [])

    const getCustomFieldTemplateByMasterEntityTypeIdAsync = async () => {
        let MasterEntityTypeId = getMasterEntityTypeId(obj.TableName);
        const response = await fetchAPI('api/v2/CustomFields/CustomFieldTemplateByMasterEntityType/' + MasterEntityTypeId, 'GET', '', true, "");
        const json = await response.json();
        if (json.length > 0) {
            SetCustomFieldsArray(json);
        }
        else {
            SetCustomFieldsArray([]);
        }
        return json;
    }

    const getMasterEntityTypeId = (tableName: string) => {
        switch (tableName) {
            case "AccountParty":
                return 'E448AED9-EAB5-4CF7-A171-2A86BE2BBA9E';
            case "AccountEmployeeExpenseSheet":
                return 'A55DF02B-FBFB-4873-B582-6968FBAEE589';
            case "AccountExpenseEntry":
                return '756E4460-A713-4BEE-B3F0-708FC5BE21BD';
            case "AccountProjectTask":
                return 'C9A8F7F1-1B2D-48DA-AAE9-74F92892A896';
            case "AccountEmployee":
                return '3601AE9B-3F82-4C80-9574-751F9A124FA8';
            case "AccountProject":
                return '13DBFF37-A092-4AE2-A919-775CBED0EDC0';
            case "AccountEmployeeTimeEntryPeriod":
                return '369ED0FB-D317-4244-9F20-B7D834521E2B';
        }
    }

    const handlePageChange = (pageNumber: any) => {
        setCurrentPage(pageNumber);
    };
    const handlePageChangeSheet = (pageNo: any) => {
        setCurrentPagesheet(pageNo);
    };

    const handleSearch = (event: any) => {
        const { value } = event.target;
        setSearchTerm(value);
        setCurrentPage(1);
    };

    const handleSearchSheet = (event: any) => {
        const { value } = event.target;
        setSearchTermSheet(value);
        setCurrentPagesheet(1);
    };

    const handlePageSizeChange = (selectedOption: any) => {
        const { value, label } = selectedOption;
        setPageSize(Number(value));
        setCurrentPage(1);
    };

    const handlePageSizeChangeSheet = (selectedOption: any) => {
        const { value, label } = selectedOption;
        setPageSizesheet(Number(value));
        setCurrentPagesheet(1);
    };

    const handleShowModal = (employeetimeentryId: any) => {
        setSelectedObject({ Id: employeetimeentryId, TableName: 'AccountEmployeeTimeEntry', Title: getValueFromResource('Timesheet Entries', dispatch,t) });
        dispatch(getAuditTimeEntriesAsync({ TableName: 'AccountEmployeeTimeEntry', Id: employeetimeentryId }));
        setShowModal(true);
        setIsLoader(false);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const detectValueType = (value: any) => {
        if (!value || value === '') return 'TEXT';

        const strValue = String(value).trim();
        if (strValue === 'true' || strValue === 'false') {
            return 'BOOLEAN';
        }

        const datetimePattern = /\d{4}-\d{2}-\d{2}[T\s]\d{2}:\d{2}/;
        if (datetimePattern.test(strValue)) {
            return 'DATETIME';
        }

        const datePattern = /^\d{4}-\d{2}-\d{2}$/;
        if (datePattern.test(strValue)) {
            return 'DATE';
        }

        if (!isNaN(parseFloat(value)) && isFinite(value) &&
            !/[a-zA-Z]/.test(strValue) &&
            strValue !== '0' && strValue !== '1') {
            return 'NUMERIC';
        }

        return 'TEXT';
    };

    const formatAuditValue = (value: any, cultureInfoName: any, decimalPlaces: any, fieldName: any) => {
        const name = fieldName ? fieldName.toString() : '';

        if (name.endsWith('Id') || name.endsWith('ID')) {
            return value;
        }

        let valueType = detectValueType(value);

        if (name.startsWith('Is')) {
            valueType = 'BOOLEAN';
        }

        if (name.includes('Amount')) {
            valueType = 'NUMERIC';
        }

        if (name.includes('Date')) {
            if (/\d{4}-\d{2}-\d{2}/.test(String(value))) {
                valueType = 'DATE';
            } else {
                valueType = 'TEXT';
            }
        }

        switch (valueType) {
            case 'BOOLEAN':
                const strVal = String(value).toLowerCase();
                return (strVal === '1' || strVal === 'true')
                    ? getValueFromResource('Yes', dispatch, t)
                    : getValueFromResource('No', dispatch, t);

            case 'DATETIME':
                return formatCurrntDateTime(value, cultureInfoName.toString());

            case 'DATE':
                return formatDateWithDateAndMonthName(value, cultureInfoName.toString());

            case 'NUMERIC':
                return fieldName === 'Submitted By' ? value : FormatInvoiceDecimalNumber(cultureInfoName.toString(), value, decimalPlaces);

            case 'TEXT':
            default:
                return getValueFromResource(value, dispatch, t);
        }
    };

    const filteredData: any = getFilteredList(Object.values(accountAuditList), searchTermSheet);
    const indexOfLastItem = currentPagesheet * pageSizesheet;
    const indexOfFirstItem = indexOfLastItem - pageSizesheet;
    const sheetItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const totalItems = accountAuditList.length;
    const recordsFiltered = Object.values(filteredData).length;

    const timeEntryData: any = getFilteredList(Object.values(employeeTimeEntryList), searchTerm);
    const indexOfLastItemEntry = currentPage * pageSize;
    const indexOfFirstItemEntry = indexOfLastItemEntry - pageSize;
    const TimeEntryItems = timeEntryData.slice(indexOfFirstItemEntry, indexOfLastItemEntry);
    const totalEntryItems = employeeTimeEntryList.length;
    const recordsEntryFiltered = Object.values(timeEntryData).length;

    return (
        <>
            {isLoading ? <Loader />
                : <>
                    <div className="card card-custom " style={{ height: 'calc(50vh - 55px)' }}>
                        <div className="card-header sticky-top fixed-top bg-white">
                            <h3 className="card-title fw-bold headerTitle"  >
                                {/* {t('Timesheet Period Audit')} */}
                                {getValueFromResource('Timesheet Period Audit',dispatch, t)}
                                </h3>
                            <div className="card-toolbar align-items-center">
                                <div className="position-relative">
                                    <input
                                        type="text"
                                        value={searchTermSheet}
                                        onChange={handleSearchSheet}
                                        placeholder=
                                        // {t('Search')}
                                        {getValueFromResource('Search',dispatch, t)}
                                        className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                        data-kt-user-table-filter="search"
                                    />
                                    <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}  >
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </div>
                                <div className='h-35px w-1px mx-1'></div>
                                <div className="d-flex align-items-center">
                                    <Select
                                        styles={paginationStyles}
                                        options={getPageSizeArray()}
                                        value={getPageSizeArray().find((option: any) => option.value == pageSizesheet.toString())}
                                        onChange={handlePageSizeChangeSheet}
                                        className='fs-7 fw-normal'

                                    />
                                </div>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                <div>
                                    {(sheetItems.length > 0) ? (
                                        <CustomPagination
                                            currentPage={currentPagesheet}
                                            onPageChange={handlePageChangeSheet}
                                            pageSize={pageSizesheet}
                                            totalItems={totalItems}
                                            start={(currentPagesheet - 1) * pageSizesheet}
                                            t={t}
                                            recordsFiltered={recordsFiltered}
                                        >
                                        </CustomPagination>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        <div className='card-body py-3'>
                            <div className='table-responsive'>
                                <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' >
                                    <thead>
                                        <tr className="thHeading align-middle " >
                                            <th className='w-20' >
                                                {/* {t('Updated Date')} */}
                                                {getValueFromResource('Updated Date',dispatch, t)}
                                                </th>
                                            <th className='w-20' >
                                                {/* {t('Field Name')} */}
                                                {getValueFromResource('Field Name',dispatch, t)}
                                                </th>
                                            <th className='w-20'> 
                                                {/* {t('Old Value')} */}
                                                {getValueFromResource('Old Value',dispatch, t)}
                                                </th>
                                            <th className='w-20' >
                                                {/* {t('New Value')} */}
                                                {getValueFromResource('New Value',dispatch, t)}
                                                </th>
                                            <th className='w-20' >
                                                {/* {t('Update By')} */}
                                                {getValueFromResource('Update By',dispatch, t)}
                                                </th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {sheetItems.length > 0 && sheetItems.map((auditList: any, i: any) => (
                                            <tr key={i} style={{ height: 42 }}>
                                                <td>
                                                    {/* {moment(auditList.UpdatedOn).format('M-D-YYYY - h:mm A')} */}
                                                    {formatCurrntDateTime(auditList.UpdatedOn, cultureInfoName.toString())}
                                                </td>
                                                <td>
                                                    {/* {t(auditList.FieldName)} */}
                                                    {getValueFromResource(auditList.FieldName,dispatch, t)}
                                                </td>
                                                <td >
                                                    {/* {t(auditList.OldValue)} */}
                                                    {/* {getValueFromResource(auditList.OldValue,dispatch, t)} */}
                                                    {auditList.FieldName.startsWith('Custom Field') ?
                                                        getAndSetCustomFieldValues(auditList.FieldName.replace(/\s/g, ''), auditList.OldValue, customFieldsArray, cultureInfoName.toString(), decimalPlaces) :
                                                        formatAuditValue(
                                                            auditList.OldValue,
                                                            cultureInfoName,
                                                            decimalPlaces,
                                                            auditList.FieldName)}
                                                </td>
                                                <td >
                                                    {/* {t(auditList.NewValue)} */}
                                                    {/* {getValueFromResource(auditList.NewValue,dispatch, t)} */}
                                                    {auditList.FieldName.startsWith('Custom Field') ?
                                                        getAndSetCustomFieldValues(auditList.FieldName.replace(/\s/g, ''), auditList.NewValue, customFieldsArray, cultureInfoName.toString(), decimalPlaces) :
                                                        formatAuditValue(
                                                            auditList.NewValue,
                                                            cultureInfoName,
                                                            decimalPlaces,
                                                            auditList.FieldName)}
                                                </td>
                                                <td >
                                                    {/* {t(auditList.UpdateBy)} */}
                                                    {getValueFromResource(auditList.UpdateBy,dispatch, t)}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {sheetItems.length === 0 &&
                                    <div className=''>
                                        <p className='noDataFound'>
                                            {/* {t('No Record Found')} */}
                                            {getValueFromResource('No Record Found',dispatch, t)}
                                            </p>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <br />

                    <div className="card card-custom ">
                        <div className="card-header sticky-top fixed-top bg-white">
                            <h3 className="card-title fw-bold headerTitle"  >
                                {/* {t('Timesheet Entries')} */}
                                {getValueFromResource('Timesheet Entries',dispatch, t)}
                                </h3>
                            <div className="card-toolbar align-items-center">
                                <div className="position-relative">
                                    <input
                                        type="text"
                                        value={searchTerm}
                                        onChange={handleSearch}
                                        placeholder=
                                        // {t('Search')}
                                        {getValueFromResource('Search',dispatch, t)}
                                        className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                        data-kt-user-table-filter="search"
                                    />
                                    <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}  >
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </div>
                                <div className='h-35px w-1px mx-1'></div>
                                <div className="d-flex align-items-center">
                                    <Select
                                        styles={paginationStyles}
                                        options={getPageSizeArray()}
                                        value={getPageSizeArray().find((option: any) => option.value == pageSize.toString())}
                                        onChange={handlePageSizeChange}
                                        className='fs-7 fw-normal'
                                    />
                                </div>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                <div>
                                    {(sheetItems.length > 0) ? (
                                        <CustomPagination
                                            currentPage={currentPage}
                                            onPageChange={handlePageChange}
                                            pageSize={pageSize}
                                            totalItems={totalEntryItems}
                                            start={(currentPage - 1) * pageSize}
                                            t={t}
                                            recordsFiltered={recordsEntryFiltered}
                                        >
                                        </CustomPagination>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        <div className='card-body py-3'>
                            <div className='table-responsive'>
                                <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' style={{ width: '100%' }}>
                                    <thead>
                                        <tr className="thHeading align-middle " >
                                            <th className='w-15'>
                                                {/* {t('Time Entry Date')} */}
                                                {getValueFromResource('Time Entry Date',dispatch, t)}
                                                </th>
                                            <th className='w-15'>
                                                {/* {t('Project Name')} */}
                                                {getValueFromResource('Project Name',dispatch, t)}
                                                </th>
                                            <th className='w-15'>
                                                {/* {t('Task Name')} */}
                                                {getValueFromResource('Task Name',dispatch, t)}
                                                </th>
                                            <th className='w-15'>
                                                {/* {t('BillingType')} */}
                                                {getValueFromResource('BillingType',dispatch, t)}
                                                </th>
                                            <th className='w-25'>
                                                {/* {t('Description')} */}
                                                {getValueFromResource('Description',dispatch, t)}
                                                </th>
                                            <th className='w-10 text-center'></th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {TimeEntryItems.length > 0 && TimeEntryItems.map((timeEntryDetail: any, i: any) => (
                                            <tr key={i} style={{ height: 42 }}>
                                                <td>
                                                    {/* {moment(timeEntryDetail.TimeEntryDate).format('M-D-YYYY')} */}
                                                    {formatDateWithDateAndMonthName(timeEntryDetail.TimeEntryDate, cultureInfoName.toString())}
                                                </td>
                                                <td>
                                                    {/* {t(timeEntryDetail.ProjectName)} */}
                                                    {getValueFromResource(timeEntryDetail.ProjectName,dispatch, t)}
                                                </td>

                                                <td>
                                                    {/* {t(timeEntryDetail.TaskName)} */}
                                                    {getValueFromResource(timeEntryDetail.TaskName,dispatch, t)}
                                                </td>
                                                <td>
                                                    {/* {t(timeEntryDetail.BillingType)} */}
                                                    {getValueFromResource(timeEntryDetail.BillingType,dispatch, t)}
                                                </td>                           

                                                <td>
                                                    {/* {t(timeEntryDetail.Description)}  */}
                                                    {getValueFromResource(timeEntryDetail.Description,dispatch, t)}
                                                </td>
                                                <td className='text-center'>
                                                    <Dropdown
                                                        style={{ marginLeft: 1 }}
                                                        className={clsx('cursor-pointer symbol')}
                                                        data-kt-menu-attach='parent'
                                                        data-kt-menu-placement='bottom-end'
                                                    >
                                                        <Dropdown.Toggle
                                                            variant="transparent"
                                                            className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                                            data-tooltip-id="tooltip-Description"
                                                            data-tooltip-content=
                                                            // {t("More")}
                                                            {getValueFromResource('More',dispatch, t)}
                                                            data-tooltip-place="top"
                                                        >
                                                            <i className="bi bi-three-dots fs-7"></i>
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                                            <>
                                                                <div className='menu-hover-bg-sec'>
                                                                    <Dropdown.Item
                                                                        className="menu-item me-lg-0 "
                                                                        data-bs-toggle="modal"
                                                                        data-bs-target="#timeentryModal"
                                                                        onClick={() => handleShowModal(timeEntryDetail.AccountEmployeeTimeEntryId)}
                                                                    >
                                                                        <span className="menu-icon custom-menu mb-2">
                                                                            <i className="bi bi-receipt fs-6 iconColor">
                                                                                <span className="path1"></span>
                                                                                <span className="path2"></span>
                                                                            </i>
                                                                        </span>
                                                                        <span className="menu-title custom-menu-fontsize">
                                                                            {/* {`${t('Audit')}`} */}
                                                                            {getValueFromResource('Audit',dispatch, t)}
                                                                            </span>
                                                                    </Dropdown.Item>
                                                                </div>
                                                            </>
                                                        </Dropdown.Menu>
                                                    </Dropdown>

                                                </td>

                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {TimeEntryItems.length === 0 &&
                                    <div className=''>
                                        <p className='noDataFound'>
                                            {/* {t('No Record Found')} */}
                                            {getValueFromResource('No Record Found',dispatch, t)}
                                            </p>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </>
            }
            <div className="modal drawer-overlay" tabIndex={-1} data-bs-backdrop="false" id="timeentryModal" role="dialog" aria-labelledby="exampleModalSizeSm" aria-hidden="true">
                <div className='modal-dialog modal-xl' role="document">
                    <div className='modal-content rounded'>
                        <div className="modal-header">
                            <h6 className="modal-title">
                                {/* {t('Timesheet Entries Audit')} */}
                                {getValueFromResource('Timesheet Entries Audit',dispatch, t)}
                                </h6>
                            <div
                                className="btn btn-icon btn-sm btn-active-light-primary ms-2"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <KTSVG
                                    path="/media/icons/duotune/arrows/arr061.svg"
                                    className="svg-icon svg-icon-2x"
                                />
                            </div>
                        </div>
                        <div className='modal-body pt-0 pb-15 px-5 px-xl-5' style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 300px)' }}>
                            {isLoader ? <CanvasLoader /> : <>
                                <div className="table-responsive">
                                    <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' style={{ marginLeft: '10px' }}>
                                        <thead>
                                            <tr className="thHeading align-middle " >
                                                <th className='w-20' >
                                                    {/* {t('Updated Date')} */}
                                                    {getValueFromResource('Updated Date',dispatch, t)}
                                                    </th>
                                                <th className='w-20' >
                                                    {/* {t('Field Name')} */}
                                                    {getValueFromResource('Field Name',dispatch, t)}
                                                    </th>
                                                <th className='w-20'> 
                                                    {/* {t('Old Value')} */}
                                                    {getValueFromResource('Old Value',dispatch, t)}
                                                    </th>
                                                <th className='w-20' >
                                                    {/* {t('New Value')} */}
                                                    {getValueFromResource('New Value',dispatch, t)}
                                                    </th>
                                                <th className='w-20' >
                                                    {/* {t('Update By')} */}
                                                    {getValueFromResource('Update By',dispatch, t)}
                                                    </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {timeEntryAuditList.length > 0 && timeEntryAuditList.map((timeentryaudit: any, i: any) => (
                                                <tr key={i} style={{ height: 42 }}>
                                                    <td>
                                                        {formatCurrntDateTime(timeentryaudit.UpdatedOn, cultureInfoName.toString())}
                                                    </td>
                                                    <td>
                                                        {/* {t(timeentryaudit.FieldName)} */}
                                                        {getValueFromResource(timeentryaudit.FieldName,dispatch, t)}
                                                    </td>
                                                    <td >
                                                        {/* {t(timeentryaudit.OldValue)} */}
                                                        {/* {getValueFromResource(timeentryaudit.OldValue,dispatch, t)} */}
{/*                                                         {timeentryaudit.FieldName === "Submitted Date" || timeentryaudit.FieldName === "Rejected On" ?
                                                            formatDateWithDateAndMonthName(timeentryaudit.OldValue, cultureInfoName.toString())
                                                            : timeentryaudit.FieldName === "Amount Before Tax" || timeentryaudit.FieldName === "Amount" && !isNaN(parseFloat(timeentryaudit.OldValue)) ?
                                                                FormatInvoiceDecimalNumber(cultureInfoName.toString(), timeentryaudit.OldValue, decimalPlaces)
                                                                :
                                                                timeentryaudit.FieldName.startsWith('Custom Field') ?
                                                                    setCustomFieldValues(timeentryaudit.FieldName.replace(/\s/g, ''), timeentryaudit.OldValue)
                                                                    : getValueFromResource(timeentryaudit.OldValue, dispatch, t)} */}

                                                        {timeentryaudit.FieldName.startsWith('Custom Field') ?
                                                            getAndSetCustomFieldValues(timeentryaudit.FieldName.replace(/\s/g, ''), timeentryaudit.OldValue, customFieldsArray, cultureInfoName.toString(), decimalPlaces) :
                                                            formatAuditValue(
                                                                timeentryaudit.OldValue,
                                                                cultureInfoName,
                                                                decimalPlaces,
                                                                timeentryaudit.FieldName)}
                                                    </td>
                                                    <td >
                                                        {/* {t(timeentryaudit.NewValue)} */}
                                                        {/* {getValueFromResource(timeentryaudit.NewValue,dispatch, t)} */}
{/*                                                         {timeentryaudit.FieldName === "Submitted Date" || timeentryaudit.FieldName === "Rejected On" ?
                                                            formatDateWithDateAndMonthName(timeentryaudit.NewValue, cultureInfoName.toString())
                                                            : timeentryaudit.FieldName === "Amount Before Tax" || timeentryaudit.FieldName === "Amount" && !isNaN(parseFloat(timeentryaudit.NewValue)) ?
                                                                FormatInvoiceDecimalNumber(cultureInfoName.toString(), timeentryaudit.NewValue, decimalPlaces)
                                                                :
                                                                timeentryaudit.FieldName.startsWith('Custom Field') ?
                                                                    setCustomFieldValues(timeentryaudit.FieldName.replace(/\s/g, ''), timeentryaudit.NewValue)
                                                                    : getValueFromResource(timeentryaudit.NewValue, dispatch, t)} */}
                                                        {timeentryaudit.FieldName.startsWith('Custom Field') ?
                                                            getAndSetCustomFieldValues(timeentryaudit.FieldName.replace(/\s/g, ''), timeentryaudit.NewValue, customFieldsArray, cultureInfoName.toString(), decimalPlaces) :
                                                            formatAuditValue(
                                                                timeentryaudit.NewValue,
                                                                cultureInfoName,
                                                                decimalPlaces,
                                                                timeentryaudit.FieldName)}
                                                    </td>
                                                    <td >
                                                        {/* {t(timeentryaudit.UpdateBy)} */}
                                                        {getValueFromResource(timeentryaudit.UpdateBy,dispatch, t)}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    {(!Array.isArray(timeEntryAuditList) || timeEntryAuditList.length === 0) && (
                                        <div className=''>
                                            <p className='noDataFound'>
                                                {/* {t('No Record Found')} */}
                                                {getValueFromResource('No Record Found',dispatch, t)}
                                                </p>
                                        </div>
                                    )}
                                </div>
                            </>
                            }
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary btn-sm"
                                data-bs-dismiss="modal"
                            >
                                {/* {t('Cancel')} */}
                                {getValueFromResource('Cancel',dispatch, t)}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TimesheetAudit